var map = {
	"./ar.json": 4648,
	"./be.json": 6950,
	"./cs.json": 7184,
	"./de.json": 8758,
	"./en.json": 8000,
	"./es.json": 7592,
	"./fa.json": 1596,
	"./fi.json": 802,
	"./fr.json": 8336,
	"./hi.json": 1656,
	"./it.json": 6960,
	"./ja.json": 7304,
	"./kr.json": 4440,
	"./nl.json": 8524,
	"./pl.json": 5304,
	"./pt.json": 9652,
	"./ru.json": 7264,
	"./sa.json": 8166,
	"./tr.json": 2532,
	"./uk.json": 3010,
	"./vi.json": 4084,
	"./zh.json": 4348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7924;